/* ============================================
   ZIVLIX — Conversion & UX JavaScript
   ============================================ */

(function () {
  'use strict';

  // ── Countdown Timer (session-persistent) ──
  function initCountdown() {
    var timers = document.querySelectorAll('[data-zx-countdown]');
    timers.forEach(function (el) {
      var storageKey = 'zx_deal_end';
      var stored = sessionStorage.getItem(storageKey);
      /** @type {Date} */
      var endTime;

      if (stored && parseInt(stored) > Date.now()) {
        endTime = new Date(parseInt(stored));
      } else {
        endTime = new Date();
        endTime.setHours(endTime.getHours() + 4);
        endTime.setMinutes(endTime.getMinutes() + 17);
        sessionStorage.setItem(storageKey, endTime.getTime().toString());
      }

      function update() {
        var now = new Date();
        var diff = endTime.getTime() - now.getTime();
        if (diff <= 0) {
          sessionStorage.removeItem(storageKey);
          el.innerHTML = '<span style="color:#EF4444;font-weight:700">Deal expired</span>';
          return;
        }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var hEl = el.querySelector('[data-zx-hours]');
        var mEl = el.querySelector('[data-zx-minutes]');
        var sEl = el.querySelector('[data-zx-seconds]');
        if (hEl) hEl.textContent = String(h).padStart(2, '0');
        if (mEl) mEl.textContent = String(m).padStart(2, '0');
        if (sEl) sEl.textContent = String(s).padStart(2, '0');
      }

      update();
      setInterval(update, 1000);
    });
  }

  // ── Sticky Add-to-Cart (Mobile) ───────────
  function initStickyATC() {
    const productForm = document.querySelector('.product-form');
    if (!productForm) return;

    const stickyEl = document.querySelector('.zx-sticky-atc');
    if (!stickyEl) return;

    const btn = stickyEl.querySelector('.zx-sticky-atc__btn');
    const priceEl = document.querySelector('.product__price .price-item--regular, .product__price .price-item--sale');
    const titleEl = document.querySelector('.product__title, .product-information__title');

    const priceTarget = stickyEl.querySelector('.zx-sticky-atc__price');
    if (priceEl && priceTarget) priceTarget.textContent = priceEl.textContent;
    const titleTarget = stickyEl.querySelector('.zx-sticky-atc__title');
    if (titleEl && titleTarget) titleTarget.textContent = titleEl.textContent;

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          stickyEl.classList.add('is-visible');
        } else {
          stickyEl.classList.remove('is-visible');
        }
      });
    }, { threshold: 0.1 });

    observer.observe(productForm);

    if (btn) {
      btn.addEventListener('click', function () {
        const mainBtn = /** @type {HTMLElement|null} */ (productForm.querySelector('[type="submit"]'));
        if (mainBtn) mainBtn.click();
      });
    }
  }

  // ── Scroll Reveal ─────────────────────────
  function initScrollReveal() {
    const elements = document.querySelectorAll('.zx-reveal');
    if (!elements.length) return;

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    elements.forEach(function (el) { observer.observe(el); });
  }

  // ── Sticky Header Shadow ──────────────────
  function initStickyHeader() {
    const header = document.querySelector('.section-header');
    if (!header) return;

    window.addEventListener('scroll', function () {
      if (window.scrollY > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  // ── Fake Viewers Count ────────────────────
  function initViewers() {
    const els = document.querySelectorAll('.zx-viewers__count');
    if (!els.length) return;

    function randomBetween(/** @type {number} */ a, /** @type {number} */ b) {
      return Math.floor(Math.random() * (b - a + 1)) + a;
    }

    els.forEach(function (el) {
      let count = randomBetween(8, 24);
      el.textContent = String(count);

      setInterval(function () {
        const change = Math.random() < 0.5 ? 1 : -1;
        count = Math.max(5, Math.min(40, count + change));
        el.textContent = String(count);
      }, randomBetween(4000, 8000));
    });
  }

  // ── Free Shipping Progress ────────────────
  function initFreeShipping() {
    const fills = document.querySelectorAll('.zx-free-shipping__fill');
    const threshold = 999; // ₹999 free shipping threshold

    fills.forEach(function (fill) {
      const cartTotalEl = /** @type {HTMLElement|null} */ (document.querySelector('[data-cart-total]'));
      const cartTotal = parseFloat(cartTotalEl?.dataset.cartTotal || '0');
      const pct = Math.min(100, (cartTotal / threshold) * 100);
      /** @type {HTMLElement} */ (fill).style.width = pct + '%';

      const textEl = fill.closest('.zx-free-shipping')?.querySelector('.zx-free-shipping__text');
      if (textEl) {
        if (pct >= 100) {
          textEl.innerHTML = '🎉 You\'ve unlocked <strong>FREE shipping!</strong>';
        } else {
          const remaining = (threshold - cartTotal).toFixed(0);
          textEl.innerHTML = 'Add <span class="amount">₹' + remaining + ' more</span> for FREE shipping';
        }
      }
    });
  }

  // ── Cart Item Animation ───────────────────
  function initCartAnimations() {
    document.addEventListener('cart:item-added', function () {
      const cartIcon = document.querySelector('.header__cart, .header__cart-button');
      if (cartIcon) {
        cartIcon.classList.add('cart-bump');
        setTimeout(function () { cartIcon.classList.remove('cart-bump'); }, 300);
      }
    });
  }

  // ── Product Image Zoom (Desktop) ──────────
  function initImageHover() {
    const mediaItems = document.querySelectorAll('.product__media-item');
    mediaItems.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        /** @type {HTMLElement} */ (item).style.cursor = 'zoom-in';
      });
    });
  }

  // ── Exit Intent Popup ─────────────────────
  function initExitIntent() {
    if (document.cookie.indexOf('zx_exit_shown=1') !== -1) return;
    if (!document.querySelector('.product-form, .cart-form')) return;

    let triggered = false;

    document.addEventListener('mouseleave', function (e) {
      if (e.clientY <= 5 && !triggered) {
        triggered = true;
        showExitPopup();
      }
    });

    function showExitPopup() {
      const overlay = document.createElement('div');
      overlay.className = 'zx-exit-overlay';
      overlay.innerHTML = `
        <div class="zx-exit-modal">
          <button class="zx-exit-close" aria-label="Close">&times;</button>
          <div class="zx-exit-emoji">🎁</div>
          <h2 class="zx-exit-title">Wait! Don't leave empty-handed</h2>
          <p class="zx-exit-body">You have items in your cart. Complete your order and get fast delivery!</p>
          <a href="/cart" class="zx-exit-btn">Complete My Order</a>
          <button class="zx-exit-dismiss">No thanks, I'll leave</button>
        </div>
      `;

      const style = document.createElement('style');
      style.textContent = `
        .zx-exit-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.6);z-index:9999;display:flex;align-items:center;justify-content:center;animation:fadeIn 0.25s ease;backdrop-filter:blur(4px)}
        .zx-exit-modal{background:#fff;border-radius:16px;padding:40px 32px;max-width:420px;width:calc(100% - 32px);text-align:center;position:relative;animation:fadeInUp 0.3s ease}
        .zx-exit-close{position:absolute;top:16px;right:16px;background:none;border:none;font-size:24px;cursor:pointer;color:#9CA3AF;line-height:1}
        .zx-exit-close:hover{color:#111}
        .zx-exit-emoji{font-size:48px;margin-bottom:16px}
        .zx-exit-title{font-size:22px;font-weight:800;color:#0D0D0D;margin:0 0 12px}
        .zx-exit-body{font-size:15px;color:#6B7280;margin:0 0 24px;line-height:1.6}
        .zx-exit-btn{display:block;background:#2563EB;color:#fff;border-radius:8px;padding:16px 28px;font-size:16px;font-weight:700;text-decoration:none;margin-bottom:12px;box-shadow:0 4px 14px rgba(37,99,235,0.35);transition:all 0.2s}
        .zx-exit-btn:hover{background:#1D4ED8;transform:translateY(-1px)}
        .zx-exit-dismiss{background:none;border:none;font-size:13px;color:#9CA3AF;cursor:pointer;text-decoration:underline}
        @keyframes fadeIn{from{opacity:0}to{opacity:1}}
        @keyframes fadeInUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
      `;
      document.head.appendChild(style);
      document.body.appendChild(overlay);

      function close() {
        overlay.remove();
        document.cookie = 'zx_exit_shown=1;max-age=86400;path=/';
      }

      overlay.querySelector('.zx-exit-close')?.addEventListener('click', close);
      overlay.querySelector('.zx-exit-dismiss')?.addEventListener('click', close);
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) close();
      });
    }
  }

  // ── Description Images Extractor ─────────
  // Reads infographic images from the hidden #zx-desc-source div (Liquid-rendered
  // inside the left media column) and appends them as visible stacked images.
  function initDescImages() {
    var mediaCol = document.querySelector('.product-information__media');
    if (!mediaCol) return;

    // Don't add duplicates
    if (mediaCol.querySelector('.zx-desc-images')) return;

    // Primary: use the Liquid-rendered hidden source div
    var source = document.querySelector('#zx-desc-source');
    var imgEls = source ? Array.from(source.querySelectorAll('img')) : [];

    // Fallback: scan any rte-formatter outside .product-information
    if (!imgEls.length) {
      document.querySelectorAll('rte-formatter').forEach(function (rte) {
        if (rte.closest('.product-information')) return;
        rte.querySelectorAll('img').forEach(function (img) { imgEls.push(img); });
      });
    }

    // Hide any stray below-sections with description content
    document.querySelectorAll('rte-formatter').forEach(function (rte) {
      if (rte.closest('.product-information')) return;
      var parentSection = rte.closest('[id^="shopify-section-"]');
      if (parentSection) /** @type {HTMLElement} */ (parentSection).style.display = 'none';
    });

    if (!imgEls.length) return;

    var container = document.createElement('div');
    container.className = 'zx-desc-images';

    imgEls.forEach(function (img) {
      var clone = /** @type {HTMLElement} */ (img.cloneNode(true));
      clone.removeAttribute('style');
      clone.removeAttribute('loading');
      container.appendChild(clone);
    });

    mediaCol.appendChild(container);
  }

  // ── Custom Cursor ─────────────────────────
  function initCustomCursor() {
    if (window.matchMedia('(pointer: coarse)').matches) return;

    var dot = document.createElement('div');
    dot.className = 'zx-cursor-dot';
    var ring = document.createElement('div');
    ring.className = 'zx-cursor-ring';
    document.body.appendChild(dot);
    document.body.appendChild(ring);

    var mx = -100, my = -100, rx = -100, ry = -100;

    document.addEventListener('mousemove', function (e) {
      mx = e.clientX;
      my = e.clientY;
      dot.style.left = mx + 'px';
      dot.style.top = my + 'px';
    }, { passive: true });

    (function animate() {
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      ring.style.left = rx + 'px';
      ring.style.top = ry + 'px';
      requestAnimationFrame(animate);
    })();

    document.querySelectorAll('a, button, [class*="button"], .card, product-card, label').forEach(function (el) {
      el.addEventListener('mouseenter', function () {
        dot.classList.add('is-hover');
        ring.classList.add('is-hover');
      });
      el.addEventListener('mouseleave', function () {
        dot.classList.remove('is-hover');
        ring.classList.remove('is-hover');
      });
    });
  }

  // ── Homepage Section Reveal ───────────────
  function initHomepageReveal() {
    var sels = [
      '#shopify-section-section_sbc_heading',
      '#shopify-section-section_shop_by_collection',
      '#shopify-section-section_reviews_heading',
      '#shopify-section-section_reviews_cards',
      '#shopify-section-section_loved_by_stats',
      '#shopify-section-section_why_choose_zivlix',
      '#shopify-section-section_newsletter',
    ];

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.07 });

    sels.forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      el.classList.add('zx-reveal');
      observer.observe(el);
    });
  }

  // ── Stats Counter Animation ───────────────
  function initStatsCounter() {
    var section = document.querySelector('#shopify-section-section_loved_by_stats');
    if (!section) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);

        entry.target.querySelectorAll('h2').forEach(function (el) {
          var original = el.textContent;
          var match = original.match(/(\d[\d,]*)/);
          if (!match || !match[1]) return;

          var matchedStr = match[1];
          var target = parseInt(matchedStr.replace(/,/g, ''), 10);
          var prefix = original.slice(0, original.indexOf(matchedStr));
          var suffix = original.slice(original.indexOf(matchedStr) + matchedStr.length);
          var current = 0;
          var increment = target / 60;

          var interval = setInterval(function () {
            current = Math.min(current + increment, target);
            el.textContent = prefix + Math.floor(current).toLocaleString('en-IN') + suffix;
            if (current >= target) clearInterval(interval);
          }, 16);
        });
      });
    }, { threshold: 0.35 });

    observer.observe(section);
  }

  // ── Init All ──────────────────────────────
  function init() {
    initCountdown();
    initStickyATC();
    initScrollReveal();
    initStickyHeader();
    initViewers();
    initFreeShipping();
    initCartAnimations();
    initImageHover();
    initExitIntent();
    // Using carousel gallery — description image injection disabled
    // initDescImages();
    initCustomCursor();
    initHomepageReveal();
    initStatsCounter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
